import { motion } from "framer-motion";

const ease = [0.2, 0.8, 0.2, 1];

export const Reveal = ({ children, delay = 0, y = 24, className = "", once = true, ...rest }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once, margin: "-80px" }}
    transition={{ duration: 0.8, ease, delay }}
    {...rest}
  >
    {children}
  </motion.div>
);

export const Stagger = ({ children, className = "", gap = 0.08, delay = 0 }) => (
  <motion.div
    className={className}
    initial="hidden"
    whileInView="show"
    viewport={{ once: true, margin: "-60px" }}
    variants={{ hidden: {}, show: { transition: { staggerChildren: gap, delayChildren: delay } } }}
  >
    {children}
  </motion.div>
);

export const Item = ({ children, className = "", y = 20 }) => (
  <motion.div className={className} variants={{ hidden: { opacity: 0, y }, show: { opacity: 1, y: 0, transition: { duration: 0.7, ease } } }}>
    {children}
  </motion.div>
);

// Masked line-by-line reveal for headlines. Pass lines as array of strings/nodes.
export const SplitLines = ({ lines, className = "", lineClass = "", delay = 0, as = "h1", inView = false }) => {
  const MTag = motion[as];
  const trigger = inView ? { whileInView: "show", viewport: { once: true, margin: "-40px" } } : { animate: "show" };
  return (
    <MTag className={className} initial="hidden" {...trigger}>
      {lines.map((l, i) => (
        <span key={i} className="block overflow-hidden pb-[0.08em] -mb-[0.08em]">
          <motion.span className={`block ${lineClass}`} variants={{ hidden: { y: "110%" }, show: { y: "0%", transition: { duration: 0.9, ease, delay: delay + i * 0.12 } } }}>{l}</motion.span>
        </span>
      ))}
    </MTag>
  );
};
